// 颜色相关的处理
import chroma from 'chroma-js';

export const alpha = (color?: string, number = 1) => {
  if (!color) {
    return '';
  }
  return chroma(color)
    .alpha(number)
    .css();
};
// 重新实现一下alpha函数，以确保不存在兼容性问题
// export const alpha = (start:string, end:string, pos:number = 0.6) =>{
//   let scale = chroma.scale([start, end]);
//   return scale(pos).css();
// }

// 当前颜色是否更亮（亮度>=50%)
export const isLighter = (color?: string) => {
  if (!color) {
    return false;
  }
  return chroma(color).luminance() <= 0.6;
};

export const getPendantColor = (color: string, revert: boolean = false) => {
  const lighter = isLighter(color);
  const pendantBgColor = lighter ? `#000` : `#fff`;
  const pendantIconColor = lighter ? '#fff' : '#000';

  if (revert) {
    return [
      chroma(pendantIconColor)
        .alpha(0.6)
        .css(),
      pendantBgColor
    ];
  } else {
    return [
      chroma(pendantBgColor)
        .alpha(0.6)
        .css(),
      pendantIconColor
    ];
  }
};
